import { Tag } from '@/components/tag/Tag'

export default function TableOriginTag({ documentAnalysis }: { documentAnalysis: boolean }) {
  if (!documentAnalysis) return null
  const label = 'Document Analysis'
  return (
    <span title={`Created with ${label}`} className="inline-flex shrink-0">
      <Tag variant="tonal" color="Black" size="xs" textCase="normal" shape="square">
        {label}
      </Tag>
    </span>
  )
}
